import { IStormDoorHandleEditingModel } from "../entities-generated/models/storm-door/storm-door-handle-editing-model";
import { IStormDoorHandleListing } from "../entities-generated/models/storm-door/storm-door-handle-listing";
import { IUpdateStormDoorHandleRequest } from "../entities-generated/models/storm-door/update-storm-door-handle-request";
import { ApiClient } from "./admin-api-client";

class StormDoorHandleApiClientClass {
  public getStormDoorHandleForEditing(handleId: string) {
    return ApiClient.get<IStormDoorHandleEditingModel>(`storm-doors/handles/editable/${handleId}`);
  }

  public getStormDoorHandleList() {
    return ApiClient.get<IStormDoorHandleListing[]>(`storm-doors/handles/list`);
  }

  public updateStormDoorHandle(request: IUpdateStormDoorHandleRequest) {
    return ApiClient.put<void>('storm-doors/handles', request);
  }
}

export const StormDoorHandleApiClient = new StormDoorHandleApiClientClass();